import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { BACKEND_URL } from '../../../../../variables';
import ErrorMessage from '../../../Search/components/ErrorMessage';
import IframeComponent from '../IframeComponent';

interface Props {
    id?: number;
    path?: string;
    onLoad?: () => void;
}

const XmlDocument = (props: Props) => {
    const [t] = useTranslation();
    const { id, path, onLoad } = props;
    const { xmlId } = useParams();
    const [html, setHtml] = useState('');
    const [error, setError] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<any>(t('DOCUMENT_VIEW::ERROR_MSG'));

    useEffect(() => {
        const url = `${BACKEND_URL}/publications/html${
            path?.slice(0, -3) + 'xml' ? `?path=${path?.slice(0, -3) + 'xml'}` : ''
        }`;
        axios
            .get(url)
            .then((response) => {
                setHtml(response.data);
            })
            .catch((err) => {
                setError(true);
                setErrorMessage(err.message);
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id, xmlId]);

    const handleCloseError = () => {
        setError(false);
        setErrorMessage(t('DOCUMENT_VIEW::ERROR_MSG'));
    };

    return (
        <>
            {error ? (
                <div className="d-flex justify-content-center mt-l">
                    <ErrorMessage closeMsg={handleCloseError} errorMsg={errorMessage} />
                </div>
            ) : (
                <div>
                    <IframeComponent srcDoc={`${html}`} onLoad={onLoad} />
                    <div>
                        <p>
                            {t('SEARCH_RESULTS::LEGAL_NOTICE_TOP_PARAGRAPH')}
                            <br />
                            <br />
                            {t('SEARCH_RESULTS::LEGAL_NOTICE_1ST_PARAGRAPH')}

                            <br />
                            <br />

                            {t('SEARCH_RESULTS::LEGAL_NOTICE_2ND_PARAGRAPH')}
                            <a
                                href={
                                    'https://archive.epo.org/epo/pubs/oj007/08_07/special_edition_3_epc_2000_decisions.pdf' ||
                                    '#'
                                }
                                target="_blank"
                                title=""
                                rel="noreferrer"
                                style={{ textDecoration: 'underline', color: 'inherit' }}
                            >
                                {t('SEARCH_RESULTS::LEGAL_NOTICE_2ND_PARAGRAPH_2ND')}
                            </a>

                            {t('SEARCH_RESULTS::LEGAL_NOTICE_2ND_PARAGRAPH_3ND')}
                        </p>
                    </div>
                </div>
            )}
        </>
    );
};

export default XmlDocument;
